// extracted by mini-css-extract-plugin
export default {"leaderboard":"LoggedOutLeaderboard--leaderboard--rdbO+","content":"LoggedOutLeaderboard--content--3p0Me"};